// Gera o payload "copia e cola" do PIX (BR Code / padrão EMV do Bacen).
// Use com a lib `qrcode` para render do QR: QRCode.toDataURL(gerarPixPayload(...))

const ACENTOS = new RegExp("[\\u0300-\\u036f]", "g");

function limpar(txt, max) {
  return (txt || "")
    .normalize("NFD")
    .replace(ACENTOS, "")
    .replace(/[^\x20-\x7E]/g, "") // só ASCII imprimível
    .toUpperCase()
    .slice(0, max);
}

function campo(id, valor) {
  const tam = valor.length.toString().padStart(2, "0");
  return `${id}${tam}${valor}`;
}

export function crc16(payload) {
  let crc = 0xffff;
  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = (crc & 0x8000) ? ((crc << 1) ^ 0x1021) : (crc << 1);
      crc &= 0xffff;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, "0");
}

function cpfValido(d) {
  if (!/^\d{11}$/.test(d) || /^(\d)\1{10}$/.test(d)) return false;
  const digito = n => { let s = 0; for (let i = 0; i < n; i++) s += Number(d[i]) * (n + 1 - i); return ((s * 10) % 11) % 10; };
  return digito(9) === Number(d[9]) && digito(10) === Number(d[10]);
}

/* A chave no formato que o Pix exige (senão o app do banco não reconhece o
   QR): celular "+55" + DDD + número, CPF/CNPJ só com números, e-mail e chave
   aleatória em minúsculas. Formato desconhecido segue como digitado. */
export function normalizarChavePix(chave) {
  const c = String(chave || "").trim();
  if (!c) return "";
  if (c.includes("@")) return c.replace(/\s/g, "").toLowerCase();
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(c)) return c.toLowerCase();
  const d = c.replace(/\D/g, "");
  if (c.startsWith("+")) return `+${d}`;
  if (/^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(c)) return d;                // CPF formatado
  if (d.length === 14) return d;                                          // CNPJ
  if (d.length === 11 && !/[()\s]/.test(c) && cpfValido(d)) return d;    // CPF só com números
  if (d.length === 10 || d.length === 11) return `+55${d}`;               // celular com DDD
  if ((d.length === 12 || d.length === 13) && d.startsWith("55")) return `+${d}`;
  return c;
}

// Para a tela de configuração mostrar como a chave vai ser usada
export function tipoChavePix(chave) {
  const c = normalizarChavePix(chave);
  if (!c) return "";
  if (c.includes("@")) return "E-mail";
  if (c.startsWith("+")) return "Celular";
  if (/^\d{11}$/.test(c)) return "CPF";
  if (/^\d{14}$/.test(c)) return "CNPJ";
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-/.test(c)) return "Chave aleatória";
  return "Formato não reconhecido";
}

/**
 * @param {object} p
 * @param {string} p.chave   chave PIX (cpf, email, telefone, aleatória)
 * @param {string} p.nome    nome do beneficiário (máx 25)
 * @param {string} p.cidade  cidade (máx 15)
 * @param {number} [p.valor] valor da transação (opcional)
 * @param {string} [p.txid]  identificador do pedido (opcional)
 * @returns {string} payload copia e cola
 */
export function gerarPixPayload({ chave, nome, cidade, valor, txid = "***" }) {
  const chaveOk = normalizarChavePix(chave);
  if (!chaveOk) return "";
  const merchant = campo("00", "br.gov.bcb.pix") + campo("01", chaveOk);
  const valorStr = valor ? Number(valor).toFixed(2) : "";
  const txidLimpo = limpar(txid, 25).replace(/[^A-Z0-9]/g, "") || "***";

  let payload =
    campo("00", "01") +                       // formato
    campo("26", merchant) +                   // conta do recebedor
    campo("52", "0000") +                     // categoria
    campo("53", "986") +                      // moeda BRL
    (valorStr ? campo("54", valorStr) : "") + // valor
    campo("58", "BR") +                        // país
    campo("59", limpar(nome, 25) || "LOJA") +  // nome
    campo("60", limpar(cidade, 15) || "CIDADE") + // cidade
    campo("62", campo("05", txidLimpo)) +     // dados adicionais (txid)
    "6304";                                    // CRC placeholder

  return payload + crc16(payload);
}
